var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Calendar-3--Streamline-Ultimate",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Calendar 3 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.75 3.75H2.25c-0.82843 0 -1.5 0.67157 -1.5 1.5v16.5c0 0.8284 0.67157 1.5 1.5 1.5h19.5c0.8284 0 1.5 -0.6716 1.5 -1.5V5.25c0 -0.82843 -0.6716 -1.5 -1.5 -1.5Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.75 9.75h22.5",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 6V0.75",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.25 6V0.75",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M5.625 14.25c-0.20711 0 -0.375 -0.1679 -0.375 -0.375s0.16789 -0.375 0.375 -0.375",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M5.625 14.25c0.20711 0 0.375 -0.1679 0.375 -0.375s-0.16789 -0.375 -0.375 -0.375",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M5.625 19.5c-0.20711 0 -0.375 -0.1679 -0.375 -0.375s0.16789 -0.375 0.375 -0.375",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M5.625 19.5c0.20711 0 0.375 -0.1679 0.375 -0.375s-0.16789 -0.375 -0.375 -0.375",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M12 14.25c-0.2071 0 -0.375 -0.1679 -0.375 -0.375s0.1679 -0.375 0.375 -0.375",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M12 14.25c0.2071 0 0.375 -0.1679 0.375 -0.375S12.2071 13.5 12 13.5",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M12 19.5c-0.2071 0 -0.375 -0.1679 -0.375 -0.375s0.1679 -0.375 0.375 -0.375",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M12 19.5c0.2071 0 0.375 -0.1679 0.375 -0.375s-0.1679 -0.375 -0.375 -0.375",
    strokeWidth: 1.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M18.375 14.25c-0.2071 0 -0.375 -0.1679 -0.375 -0.375s0.1679 -0.375 0.375 -0.375",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M18.375 14.25c0.2071 0 0.375 -0.1679 0.375 -0.375s-0.1679 -0.375 -0.375 -0.375",
    strokeWidth: 1.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M18.375 19.5c-0.2071 0 -0.375 -0.1679 -0.375 -0.375s0.1679 -0.375 0.375 -0.375",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M18.375 19.5c0.2071 0 0.375 -0.1679 0.375 -0.375s-0.1679 -0.375 -0.375 -0.375",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.fe2392f978afc5d34b393010fd7a1068.svg";
export { ForwardRef as ReactComponent };